module.exports = __webpack_public_path__ + "static/img/Group4@2x.81155df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Group4@2x.png
// module id = ww9l
// module chunks = 1